<template>
    <div class="custom-radio">
        <span v-if="required">*</span>
        {{ label }}
        <div class="radio-group">
          <label v-for="(item, index) in options" :key="index" class="radio">
            <input type="radio" :name="label" :value="item.value" @change="$emit('input', $event.target.value)" :checked="item.value === value" :required="required">
            <span></span>
            {{ item.text }}
          </label>
        </div>
    </div>
</template>

<script>
export default {
	props: {
		label: String,
		value: [String, Number],
		required: Boolean,
		options: Array
	}
}
</script>

<style lang="scss" scoped>
    .custom-radio {
        margin-bottom: 2rem;
        width: 100%;

        .radio-group, .radio {
          display: flex;
          align-items: center;
        }

        span {
          color: #F4949A;
        }

        label {
          margin-top: 2rem;
          position: relative;
          cursor: pointer;

          &:not(:last-child) {
            margin-right: 1.5rem;
          }

          span {
            display: inline-block;
            height: 2rem;
            width: 2rem;
            border-radius: 50%;
            border: .2rem solid #E6EAF2;
            margin-right: .5rem;
            transition: 0.3s;
            pointer-events: none;
          }

          input {
            appearance: none;
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
          }

          input:checked + span {
            background-color: #2DC4B6;
          }

        }
    }
</style>
